function message () {
  return {
    application: {
      title: 'Tech@Shopee Virtual Career Day 2021',
      desc: 'Tech@Shopee Virtual Career Day 2021, happening on 25 September 2021 and 2 October 2021, is a series of online webinars featuring the exciting tech teams behind the scenes of Shopee. Join the various sharing sessions by our Engineering, Product Management, Data and UI/UX Design teams and hear about the impactful projects we do at Shopee. Get your burning questions answered by our technical recruitment team and our tech leaders. Programme your Tech Career with Shopee today!',
      startDate: '25 September 2021',
      endDate: '2 October 2021'
    },
    navbar: [{
      text: 'About',
      href: '#about'
    }, {
      text: 'What to Expect',
      href: '#expect'
    }, {
      text: 'Program',
      href: '#program'
    }, {
      text: 'FAQ',
      href: '#FAQ'
    }, {
      text: 'Contact',
      href: '#contact'
    }, {
      text: 'Career',
      href: 'https://careers.shopee.sg/',
      target: '_blank'
    }, {
      text: 'Register Now',
      href: 'https://bit.ly/3Avg4zt',
      target: '_blank'
    }],
    banner: {
      title: 'TECH @ SHOPEE',
      sutTitle: 'VIRTUAL CAREER DAY 2021',
      time: '25 September & 2 October 2021',
      desc: 'Registration closes in',
      register: 'Register Now'
    },
    about: {
      title: 'About',
      desc: [
        'Tech@Shopee Virtual Career Day 2021 is a series of online webinars which aims to bring you behind the scenes with our Shopee tech teams. Our tech teams are expanding and we are looking for outstanding tech talents to join our growing team. So get ready to learn about our Machine Learning, Design, Engineering, and Product Management teams!',
        'Programme your Tech Career with Shopee today!'
      ]
    },
    expect: {
      title: 'What to Expect?',
      list: [{
        desc: 'Sharing sessions by our Engineering, Product Management, Algorithm and UI/UX Design teams',
        icon: require('@tc/assets/icons/expect_1.svg')
      }, {
        desc: 'Q&A with Shopee representatives',
        icon: require('@tc/assets/icons/expect_2.svg')
      }, {
        desc: '1-to-1 networking opportunities with our webinar speakers',
        icon: require('@tc/assets/icons/expect_3.svg')
      }, {
        desc: 'Stand to walk away with prizes at our lucky draw at the end of each day',
        icon: require('@tc/assets/icons/expect_4.svg')
      }]
    },
    sponsor: {
      title: 'Lucky Draw & Sponsor',
      attractiveInfo: {
        title: 'Attractive Logitech products waiting for you to win!',
        productList: [{
          title: 'First Prize',
          img: require('@tc/assets/images/attractive-1.jpg'),
          mobileImg: require('@tc/assets/images/attractive-mobile-1.jpg'),
          name: 'MX Anywhere 3 (Black) + C920',
          // qty: '2 Sets',
          worth: '328'
        }, {
          title: 'Second Prize',
          img: require('@tc/assets/images/attractive-2.jpg'),
          mobileImg: require('@tc/assets/images/attractive-mobile-2.jpg'),
          name: 'MX Anywhere 3 (Black) + H340',
          // qty: '2 Sets',
          worth: '184'
        }, {
          title: 'Third Prize',
          img: require('@tc/assets/images/attractive-3.jpg'),
          mobileImg: require('@tc/assets/images/attractive-mobile-3.jpg'),
          name: 'MX Anywhere 3 (Black)',
          // qty: '2 Sets',
          worth: '139'
        }]
      },
      elevateInfo: {
        title: 'Check out these Logitech products to elevate your computer experience',
        productList: [{
          img: require('@tc/assets/images/elevate-1.png'),
          mainTitle: 'THINK IT. MASTER IT.',
          subTitle: 'The Master Series by Logitech',
          desc: 'Introducing The Master Series by Logitech, a range of products that unleash your capability to create, make, and do. Master your next project with tools that transform the way you work – from revolutionizing your creative process to helping you focus and get in your flow.'
        }, {
          img: require('@tc/assets/images/elevate-2.png'),
          mainTitle: 'WORK FROM HOME ESSENTIALS',
          subTitle: '',
          desc: 'C920 delivers remarkably crisp and detailed Full HD video, 78° field of view, and HD auto light correction. Pair it up with the H340, a perfect everyday headset with a simple plug-and-play connection and a noise-canceling microphone that delivers clear digital audio. Everything you need to look great and sound great in conference calls.'
        }]
      }
    },
    eligibility: {
      title: 'Eligibility',
      list: [{
        question: 'Who can join?',
        answers: [
          'Whether you are an undergraduate or postgraduate planning a career, working professional looking for a mid-career change or simply looking for an opportunity to venture into tech in Singapore, we welcome you to join us! ',
          'Participants from across the region are also warmly invited.'
        ]
      }, {
        question: 'How to join?',
        answers: [
          'Fill in the registration form. Look out for our confirmation email and you’re set to go!',
        ]
      }]
    },
    program: {
      title: 'Program',
      pcTableInfo: [{
        time: '25 September',
        headerList: [{
          text: 'Start Time'
        }, {
          text: 'End Time'
        }, {
          text: 'Session #1',
          flex: 2
        }, {
          text: 'Session #2',
          flex: 2
        }],
        list: [{
          col: [{
            text: '10:00 AM'
          }, {
            text: '10:05 AM'
          }, {
            text: 'Opening Address',
            flex: 4
          }]
        }, {
          col: [{
            text: '10:05 AM'
          }, {
            text: '11:05 AM'
          }, {
            text: 'Backend Engineering at Scale — Checkout & Order',
            flex: 2
          }, ,{
            text: 'Problem Solving with Design',
            flex: 2
          }]
        }, {
          col: [{
            text: '11:05 AM'
          }, {
            text: '11:15 AM'
          }, {
            text: 'Break Time',
            flex: 4
          }]
        },  {
          col: [{
            text: '11:15 AM'
          }, {
            text: '12:15 PM'
          }, {
            text: 'AI-Powered Search in Shopee',
            flex: 2
          }, ,{
            text: 'Uncovering What a Marketplace Product Manager Does',
            flex: 2
          }]
        }, {
          col: [{
            text: '12:15 PM'
          }, {
            text: '12:25 PM'
          }, {
            text: 'Break Time',
            flex: 4
          }]
        }, {
          col: [{
            text: '12:25 PM'
          }, {
            text: '12:50 PM'
          }, {
            text: 'Mass Q&A',
            flex: 4
          }]
        }, {
          col: [{
            text: '12:50 PM'
          }, {
            text: '1:00 PM'
          }, {
            text: 'Closing Remarks & Announcements',
            flex: 4
          }]
        }, {
          col: [{
            text: '1:00 PM',
            flex: 2
          }, {
            text: 'End of Day1',
            flex: 4
          }]
        }]
      }, {
        time: '2 October',
        headerList: [{
          text: 'Start Time'
        }, {
          text: 'End Time'
        }, {
          text: 'Session #1',
          flex: 2
        }, {
          text: 'Session #2',
          flex: 2
        }],
        list: [{
          col: [{
            text: '10:00 AM'
          }, {
            text: '10:05 AM'
          }, {
            text: 'Opening Address',
            flex: 4
          }]
        }, {
          col: [{
            text: '10:05 AM'
          }, {
            text: '11:05 AM'
          }, {
            text: 'App Development in Shopee',
            flex: 2
          }, ,{
            text: 'Enabling Financial Inclusion Through a Career in FinTech Product Management',
            flex: 2
          }]
        }, {
          col: [{
            text: '11:05 AM'
          }, {
            text: '11:15 AM'
          }, {
            text: 'Break Time',
            flex: 4
          }]
        },  {
          col: [{
            text: '11:15 AM'
          }, {
            text: '12:15 PM'
          }, {
            text: 'Machine Learning for Liveness Check (Facial Recognition)',
            flex: 2
          }, ,{
            text: 'Unfolding the Journey of a Parcel: Supply Chain with Technology',
            flex: 2
          }]
        }, {
          col: [{
            text: '12:15 PM'
          }, {
            text: '12:5 PM'
          }, {
            text: 'Break Time',
            flex: 4
          }]
        }, {
          col: [{
            text: '12:25 PM'
          }, {
            text: '12:50 PM'
          }, {
            text: 'Mass Q&A',
            flex: 4
          }]
        }, {
          col: [{
            text: '12:50 PM'
          }, {
            text: '1:00 PM'
          }, {
            text: 'Closing Remarks & Announcements',
            flex: 4
          }]
        }, {
          col: [{
            text: '1:00 PM',
            flex: 2
          }, {
            text: 'End of Day2',
            flex: 4
          }]
        }]
      }],
      mobileTableInfo: [{
        time: '25 September',
        headerList: [{
          text: 'Time',
          flex: 2
        }, {
          text: 'Session #1',
          flex: 3
        }, {
          text: 'Session #2',
          flex: 3
        }],
        list: [{
          col: [{
            text: '10:00am - 10:05am',
            flex: 2
          }, {
            text: 'Opening Address',
            flex: 6
          }]
        }, {
          col: [{
            text: '10:05am - 11:05am',
            flex: 2
          }, {
            text: 'Backend Engineering at Scale — Checkout & Order',
            flex: 3
          }, ,{
            text: 'Problem Solving with Design',
            flex: 3
          }]
        }, {
          col: [{
            text: '11:05am - 11:15am',
            flex: 2
          }, {
            text: 'Break Time',
            flex: 6
          }]
        },  {
          col: [{
            text: '11:15am - 12:15am',
            flex: 2
          }, {
            text: 'AI-Powered Search in Shopee',
            flex: 3
          }, ,{
            text: 'Uncovering What a Marketplace Product Manager Does',
            flex: 3
          }]
        }, {
          col: [{
            text: '12:15am - 12:25pm',
            flex: 2
          }, {
            text: 'Break Time',
            flex: 6
          }]
        }, {
          col: [{
            text: '12:25pm 12:50pm',
            flex: 2
          }, {
            text: 'Mass Q&A',
            flex: 6
          }]
        }, {
          col: [{
            text: '12:50am - 1:00pm',
            flex: 2
          }, {
            text: 'Closing Remarks & Announcements',
            flex: 6
          }]
        }, {
          col: [{
            text: '1:00pm',
            flex: 2
          }, {
            text: 'End of Day1',
            flex: 6
          }]
        }]
      }, {
        time: '2 October',
        headerList: [{
          text: 'Time',
          flex: 2
        }, {
          text: 'Session #1',
          flex: 3
        }, {
          text: 'Session #2',
          flex: 3
        }],
        list: [{
          col: [{
            text: '10:00am - 10:05am',
            flex: 2
          }, {
            text: 'Opening Address',
            flex: 6
          }]
        }, {
          col: [{
            text: '10:05am - 11:05am',
            flex: 2
          }, {
            text: 'App Development in Shopee',
            flex: 3
          }, ,{
            text: 'Enabling Financial Inclusion Through a Career in FinTech Product Management',
            flex: 3
          }]
        }, {
          col: [{
            text: '11:05am - 11:15am',
            flex: 2
          }, {
            text: 'Break Time',
            flex: 6
          }]
        },  {
          col: [{
            text: '11:15am - 12:15am',
            flex: 2
          }, {
            text: 'Machine Learning for Liveness Check (Facial Recognition)',
            flex: 3
          }, ,{
            text: 'Unfolding the Journey of a Parcel: Supply Chain with Technology',
            flex: 3
          }]
        }, {
          col: [{
            text: '12:15am - 12:25pm',
            flex: 2
          }, {
            text: 'Break Time',
            flex: 6
          }]
        }, {
          col: [{
            text: '12:25pm 12:50pm',
            flex: 2
          }, {
            text: 'Panel Discussion & Q&A',
            flex: 6
          }]
        }, {
          col: [{
            text: '12:50am - 1:00pm',
            flex: 2
          }, {
            text: 'Closing Remarks & Announcements',
            flex: 6
          }]
        }, {
          col: [{
            text: ' 1:00pm',
            flex: 2
          }, {
            text: 'End of Day2',
            flex: 6
          }]
        }]
      }]
    },
    sessions: {
      title: 'What can you expect from each sharing session?',
      list: [{
        desc: 'Get to know what #LifeatShopee is like, in our Shopee teams - from learning & mentorship initiatives, to our work culture.',
        icon: require('@tc/assets/icons/session_1.svg')
      }, {
        desc: 'Learn more about our high-impact projects that empower millions of users in the region.',
        icon: require('@tc/assets/icons/session_2.svg')
      }, {
        desc: 'Discover the skill sets required for each role, and how to score an interview with the team.',
        icon: require('@tc/assets/icons/session_3.svg')
      }, {
        desc: 'Ask our tech teams and recruiters any questions you may have about the team, role or project!',
        icon: require('@tc/assets/icons/session_4.svg')
      }]
    },
    speaker: {
      title: 'More About Sessions and Speakers',
      switchInfos: [{
        day: 'Day 1',
        date: '25 September',
      }, {
        day: 'Day 2',
        date: '2 October',
      }],
      listMap: {
        0: [
          {
            teamName: 'Shopee Design Team',
            sessionTitle: 'About the session',
            sessionDesc: 'Problem Solving with Design',
            speakerTitle: 'About the speaker',
            speakersInfo: [
              {
                img: require('@tc/assets/images/speaker-alden.jpg'),
                mobileImg: require('@tc/assets/images/speaker-alden-mobile.jpg'),
                name: 'Alden',
                speakerDesc: 'Alden is part of the Search, Recommendations & Ads Design team. His work covers a variety of consumer and enterprise projects to deliver the best possible user experience to buyers & sellers alike, while continuously discovering new customer opportunities in the process.',
                speakerQuote: '“Growth happens when you are comfortable with being uncomfortable.”'
              }
            ]
          },
          {
            teamName: 'Shopee Engineering Team',
            sessionTitle: 'About the session',
            sessionDesc: 'Backend Engineering at Scale — Checkout & Order',
            speakerTitle: 'About the speaker',
            speakersInfo: [
              {
                img: require('@tc/assets/images/speaker-edwin.jpg'),
                mobileImg: require('@tc/assets/images/speaker-edwin-mobile.jpg'),
                name: 'Edwin',
                speakerDesc: 'Edwin is the Engineering lead of the Marketplace Checkout Backend team, and is currently focusing on building reliable, maintainable, and performant checkout services. Aside from solving challenging technical problems, he is also a big supporter of continuous learning and growth in his team.',
                speakerQuote: '“When I see a challenge, I see an opportunity to grow instead.”'
              },
              {
                img: require('@tc/assets/images/speaker-thomas.jpg'),
                mobileImg: require('@tc/assets/images/speaker-thomas-mobile.jpg'),
                name: 'Thomas',
                speakerDesc: 'Thomas is the technical lead of the Marketplace Order Backend Team, and is focused on building highly scalable services to support the business’ rapid growth. Apart from leading his team, he enjoys coming up with novel solutions for the unique challenges faced by Shopee. He also believes in the human capacity to learn, and that nothing is impossible when working as a team.',
                speakerQuote: '“Together, we can achieve more.”'
              },
              {
                img: require('@tc/assets/images/speaker-xianyou.jpg'),
                mobileImg: require('@tc/assets/images/speaker-xianyou-mobile.jpg'),
                name: 'Xian You',
                speakerDesc: 'Xian You is the Engineering lead of the Marketplace Order team. He has been with Shopee since its inception, and has worked on Payments, Logistics, and the Operations portal. Now, he leads a team of engineers to build the lifecycle of orders flowing through the Shopee marketplace, with a focus on architecture, people, and culture. He hopes to empower the next generation of software engineers to grow not just in their technical skills, but also as responsible and fulfiled individuals who are able to create impact in their own way.',
                speakerQuote: '“To give is a gift.”'
              }
            ]
          },
          {
            teamName: 'Shopee Algorithm Engineering Team',
            sessionTitle: 'About the session',
            sessionDesc: 'AI-Powered Search in Shopee',
            speakerTitle: 'About the speaker',
            speakersInfo: [
              {
                img: require('@tc/assets/images/speaker-thao.jpg'),
                mobileImg: require('@tc/assets/images/speaker-thao-mobile.jpg'),
                name: 'Thao',
                speakerDesc: 'Thao is a Machine Learning Engineer from the Search team, where she works on  projects to enhance the Shopee Search feature. Thao is now working on improving Shopee’s Search Recall.',
                speakerQuote: '“Don’t be afraid to fail. Be afraid not to try.”'
              },
              {
                img: require('@tc/assets/images/speaker-zhiqiang.jpg'),
                mobileImg: require('@tc/assets/images/speaker-zhiqiang-mobile.jpg'),
                name: 'Zhiqiang',
                speakerDesc: 'Zhiqiang is an expert engineer from the Search team, and works on projects relating to search ranking and ranking algorithms.',
                speakerQuote: '“Every project is a bridge that connects research and the real world.”'
              }
            ]
          },
          {
            teamName: 'Shopee Product Management Team',
            sessionTitle: 'About the session',
            sessionDesc: 'Uncovering What a Marketplace Product Manager Does',
            speakerTitle: 'About the speaker',
            speakersInfo: [
              {
                img: require('@tc/assets/images/speaker-samuel.jpg'),
                mobileImg: require('@tc/assets/images/speaker-samuel-mobile.jpg'),
                name: 'Samuel',
                speakerDesc: 'Samuel is a product manager from the Marketplace Landing team. He has worked on several front end pages like the Homepage and Product Details Page, and has shipped out numerous cross team and high impact features benefitting buyers and sellers alike. He is currently managing a team of new product management professionals in Shopee.',
                speakerQuote: `“Don't let perfection be the enemy of progress.”`
              },
              {
                img: require('@tc/assets/images/speaker-terrence.jpg'),
                mobileImg: require('@tc/assets/images/speaker-terrence-mobile.jpg'),
                name: 'Terrence',
                speakerDesc: 'Terrence is a product manager from the Marketplace Order Team. He is currently leading the Retail Order sub-team, which is responsible for driving solutions that support Shopee Retail business. He has also been involved in projects that enhance the Shopee warehouse fulfillment service.',
                speakerQuote: '“Being able to make an impact on the lives of many is what keeps me motivated.”'
              }
            ]
          }
        ],
        1:[
          {
            teamName: 'Shopee Algorithm Engineering Team',
            sessionTitle: 'About the session',
            sessionDesc: 'Machine Learning for Liveness Check (Facial Recognition)',
            speakerTitle: 'About the speaker',
            speakersInfo: [
              {
                img: require('@tc/assets/images/speaker-fan.jpg'),
                mobileImg: require('@tc/assets/images/speaker-fan-mobile.jpg'),
                name: 'Zhitao',
                speakerDesc: 'Zhitao is an Expert Algorithm Engineer from the Identity Verification team, where he was involved in the development of the facial liveness check verification in mobile devices using AI technology for financial services and customer onboarding in the Shopee app. Zhitao also leads the liveness check direction with his team.',
                speakerQuote: `“Keep on learning to keep track of the latest technologies, and consistently create valuable products to support the company's rapid growth.”`
              }
            ]
          },
          {
            teamName: 'Shopee Engineering Team',
            sessionTitle: 'About the session',
            sessionDesc: 'App Development in Shopee',
            speakerTitle: 'About the speaker',
            speakersInfo: [
              {
                img: require('@tc/assets/images/speaker-zhixing.jpg'),
                mobileImg: require('@tc/assets/images/speaker-zhixing-mobile.jpg'),
                name: 'Zhixing',
                speakerDesc: 'Zhixing is an engineer working on the Shopee iOS app, where he was involved in the full cycle of app development and release. Zhixing also manages and leads the daily development of the Shopee iOS app.',
                speakerQuote: `“Stay Hungry. Stay Foolish.”`
              }
            ]
          },
          {
            teamName: 'Shopee Product Management Team',
            list: [
              {
                sessionTitle: 'About the session',
                sessionDesc: 'Enabling Financial Inclusion Through a Career in FinTech Product Management',
                speakerTitle: 'About the speaker',
                speakersInfo: [
                  {
                    img: require('@tc/assets/images/speaker-johnson.jpg'),
                    mobileImg: require('@tc/assets/images/speaker-johnson-mobile.jpg'),
                    name: 'Johnson',
                    speakerDesc: 'Johnson is a product manager from the Financial Service team, and currently leads his team with the planning and delivery of end-to-end banking system functions. Johnson has also been involved in the launch of financial products across our Southeast Asian markets.',
                    speakerQuote: `“Constantly exploring new opportunities across the region with young and energetic teammates.”`
                  }
                ]
              },
              {
                sessionTitle: 'About the session',
                sessionDesc: 'Unfolding the Journey of a Parcel: Supply Chain with Technology',
                speakerTitle: 'About the speaker',
                speakersInfo: [
                  {
                    img: require('@tc/assets/images/speaker-yean.jpg'),
                    mobileImg: require('@tc/assets/images/speaker-yean-mobile.jpg'),
                    name: 'Yean Huar',
                    speakerDesc: `Yean Huar is a business product manager from the Supply Chain team, where she drives and actualises outbound features in Shopee's warehouse management system. She now works on the Shopee Express product line, where she brings her expertise on warehouse workforce management to develop the management system of Shopee's in-house logistics workers.`,
                    speakerQuote: `“Creating and working on impactful products excites me in my journey with Shopee.”`
                  },
                  {
                    img: require('@tc/assets/images/speaker-luo.jpg'),
                    mobileImg: require('@tc/assets/images/speaker-luo-mobile.jpg'),
                    name: 'Luo Hao',
                    speakerDesc: `Luo Hao is a business product manager from the Supply Chain team, overseeing Inbound and Return business for Shopee’s Warehouse Management System. He leads his team with his expertise in supply chain from previous industry experience.`,
                    speakerQuote: `“If you fail to plan, you are planning to fail.”`
                  }
                ]
              }
            ]
          }
        ]
      },
    },
    faq: {
      title: 'FAQ',
      sections: [{
        list: [{
          question: 'When will registration close?',
          desc: ['The registration will close on 24 September 2021, 12pm (Singapore Time).']
        }, {
          question: 'Where will the Tech@Shopee Virtual Career Day event be held?',
          desc: ['It will be held online. More details will be shared with registered attendees nearer to the date of the event.']
        }, {
          question: 'Am I required to join all the sessions?',
          desc: ['You don’t have to! You can join the session you are interested in by indicating your preference in the registration form.']
        }, {
          question: 'I am only interested in hearing from one of the teams. Can I join in only for that segment?',
          desc: ['Yes, you can join in at the specified time.']
        }, {
          question: 'The team that I’m interested to hear from is not featured in the schedule. How do I learn more about them?',
          desc: [
            'You may refer to our website <a href="https://careers.shopee.sg" ref="noopener noreferrer" target="_blank">careers.shopee.sg</a> for more information or follow us on LinkedIn to get the latest updates for our upcoming webinars.'
          ]
        }, {
          question: 'Will the same content be shared for Day 1 and Day 2?',
          desc: [
            'No, the content will be different!'
        ]
        }, {
          question: 'Do I need to have any prerequisites to join the event?',
          desc: ['No, we welcome everyone!']
        }, {
          question: 'Must I wait for a confirmation email after registering?',
          desc: ['No, your registration is confirmed once you have signed up. More details will be sent in another email nearer to the date of the event.']
        }, {
          question: 'I registered but did not receive an email with the details. What should I do?',
          desc: ['We will send out the confirmation email by 24 September, 5pm (SGT). If you did not receive it then, please check your junk mail or email <a href="mailto:tech.sg@shopee.com" ref="noopener noreferrer" target="_blank">tech.sg@shopee.com</a>.']
        }, {
          question: 'Will the webinars be recorded?',
          desc: ['The webinars will not be recorded.']
        }, {
          question: 'Will the slides be shared after the event?',
          desc: ['The slides will not be shared.']
        }, {
          question: `How do I follow up on the roles that I'm interested in?`,
          desc: ['You can apply for the role you are interested in at <a href="https://careers.shopee.sg" ref="noopener noreferrer" target="_blank">careers.shopee.sg</a>.']
        }]
      }]
    },
    contact: {
      title: 'Contact',
      desc: [
        'If you have any enquiries, please send an email to <a href="mailto:tech.sg@shopee.com" target="_blank">tech.sg@shopee.com</a>.'
       ]
    },
    footer: {
      follow: 'Follow us',
      hideLogo: false,
      social: [{
        href: 'https://www.linkedin.com/company/shopee',
        name: 'linkin',
        icon: require('@tc/assets/icons/linkedin.svg')
      }, {
        href: 'https://www.facebook.com/shopeecareers/',
        name: 'facebook',
        icon: require('@tc/assets/icons/facebook.svg')
      }, {
        href: 'https://www.instagram.com/lifeatshopee/?hl=en',
        name: 'instagram',
        icon: require('@tc/assets/icons/instagram.svg')
      }, {
        href: 'https://www.youtube.com/playlist?list=PLw-SfklDWGE0ca8OWL4eP-asvDaUEiDlB',
        name: 'youtube',
        icon: require('@tc/assets/icons/youtube.svg')
      }],
      links: [[{
        text: 'About',
        href: '#about'
      }, {
        text: 'Program',
        href: '#program'
      }, {
        text: 'Contact',
        href: '#contact'
      }], [{
        text: 'What to Expect',
        href: '#expect'
      }, {
        text: 'FAQ',
        href: '#FAQ'
      }, {
        text: 'Career',
        href: 'https://careers.shopee.sg/',
        target: '_blank'
      }]],
      copyright: 'Copyright © Shopee Limited. Trademarks belong to their respective owners. All rights reserved. ',
      privacyPolicy: 'pdf/privacy-policy.pdf',
      tc: 'pdf/terms-of-service.pdf'
    }
  }
}

export default message